// extracted by mini-css-extract-plugin
export default {"subtitlesContainer":"InfoData_subtitlesContainer__dMNDW","title":"InfoData_title__ARP3x","container":"InfoData_container__WijZ+"};